import { Component, OnInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { Observable, map, startWith } from 'rxjs';
import { DataServiceService } from 'src/app/data-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-academic-student-details',
  templateUrl: './academic-student-details.component.html',
  styleUrls: ['./academic-student-details.component.scss']
})
export class AcademicStudentDetailsComponent implements OnInit {
  startDate: Date = new Date();
  myControl = new FormControl('');
  Academicdata: any;
  // enableInput : boolean = false;
  academicTerm: string = '';
  isSubmittedForm: any = false;
  //subject wise //
  subjectWise: any = [
    {
      subjectId: '',
      facultyId: '',
      feedback: '',
      feedbackStatus: 'Enabled'
    },
  ];
  // subjectdifficulties TO STORE THE DATA//
  subjectdifficulties: any = [
    {
      subjectId: '',
      facultyId: '',
      feedback: '',
      feedbackStatus: "Enabled"
    },
  ];
  //  REASONS FOR LOW PERFORMANCE   //
  subjectwisereason: any = [
    {
      subjectId: '',
      facultyId: '',
      feedback: '',
      feedbackStatus: "Enabled"
    }
  ]
  //  OBSERVATION BY   //
  observationswise: any = [
    {
      designationId: '',
      facultyId: '',
      feedback: '',
      feedbackStatus: "Enabled"
    }
  ]
  // SUGGESTION BY  //
  suggestionswise: any = [
    {
      designationId: '',
      facultyId: '',
      feedback: '',
      feedbackStatus: "Enabled"
    }
  ]
  // support required by  //
  supportwise: any = [
    {
      designationId: '',
      facultyId: '',
      feedback: '',
      feedbackStatus: "Enabled"
    }
  ]

  facultydetails: any;
  difficultyfacultydetails: any;
  reasonfacultydetails: any;
  observationfacultydetails: any;
  suggestionfacultydetails: any;
  supportfacultydetails: any;
  selectedsubjectName: any;
  filteredData: any;
  searchInput: any;
  selectedSubject: string = '';
  selectedSubjectdiffi: string = '';

  // Add a variable to store selected subjects

  selectedSubjects: number[] = [];
  selectedStudentData: boolean = false;
  studentDetails: any = [];
  examDetails: any = [];
  subjectDetails: any = [];
  designationDetails: any = [];
  tagetPlan: any;

  //admNo store here 

  admNo: any;
  difficultyadmNo: any;
  reasonsadmNo: any;
  observationadmNo: any;
  suggestionadmNo: any;
  supportadmNo: any;

  // HERE REMOVE ONE OBJECT IN ARRAY //

  duplicateData: any = [];
  duplicate_difficulty: any = [];
  duplicate_reasons: any = [];
  duplicate_observations: any = [];
  duplicate_suggestions: any = [];
  duplicate_support: any = [];

  // here hide the child //

  show: boolean = false;
  receivedStudentData: any
  @ViewChildren('input1') input1!: QueryList<ElementRef>;
  acadetails: any;
  isTypeWiseDetailsEmpty: any;
  reassigneddata: any;
  http: any;
  myform: FormGroup;

  constructor(private dataService: DataServiceService, private spinner: NgxSpinnerService, private fb: FormBuilder) {
    this.myform = this.fb.group({
      target: ['', Validators.required]
    });

  }

  ngOnInit(): void {
    const startDate = new Date();
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  addLowPermanceFields() {
    let issubjectwiseDetails: any = []
    this.subjectWise.map((item: any) => {
      if (item.feedbackStatus != "Disabled") {
        issubjectwiseDetails.push(item);
      }
    })
    if (issubjectwiseDetails.length < this.subjectDetails.length) {
      this.subjectWise.push({
        subjectId: '',
        facultyId: '',
        feedback: '',
        feedbackStatus: 'Enabled'
      });

    }
  }

  deleteLowPerformanceFields(index: any, Disabled: any) {
    console.log('val', this.subjectWise[index]);
    if (this.subjectWise[index].isFromServer) {
      this.subjectWise[index].feedbackStatus = 'Disabled';
    } else {
      this.subjectWise[index].feedbackStatus = 'Disabled';
      this.subjectWise.splice(index, 1);
    }

  }
// auto search //
  // academicsearch(academicTerm: string) {
  //   console.log('academicdetails', academicTerm);
  //   this.spinner.show();
  //   this.dataService.Academicsearch(academicTerm).subscribe((response: any) => {
  //     this.Academicdata = response;
  //     //resentaly assining to admNo academicTerm//
  //     this.academicTerm = this.Academicdata.admNo;
  //     this.newapi(academicTerm)
  //     this.selectedStudentData = true;
  //      this.input1.first.nativeElement.focus();
  //     this.spinner.hide();
  //     console.log(this.Academicdata);
  //   });
  // }

  //========= auto search ============//

  doFilter(evt: string) {
    // this.searchInput = evt;
  }

  academicsearch(academicTerm: any) {
    this.spinner.show();
    this.dataService.AcademicsearchData(academicTerm).subscribe((Response: any) => {
      this.acadetails = Response;
      // this.acadetails.feedBackList=[]
      this.spinner.hide();
      if (this.acadetails.status == "NOT_FOUND") {
        window.alert('please Enter Valid Admission Number')
      } else {
        this.selectedStudentData = true;
        this.admNo = this.acadetails.studentDetails[0].admNo;
        this.difficultyadmNo = this.acadetails.studentDetails[0].admNo
        this.reasonsadmNo = this.acadetails.studentDetails[0].admNo
        this.observationadmNo = this.acadetails.studentDetails[0].admNo;
        this.suggestionadmNo = this.acadetails.studentDetails[0].admNo;
        this.supportadmNo = this.acadetails.studentDetails[0].admNo;

        // STUDENT DETALIS RESPONSE //

        // console.log('totalacademic', this.acadetails);
        this.studentDetails = this.acadetails.studentDetails;
        this.examDetails = this.acadetails.examDetails;
        this.subjectDetails = this.acadetails.groupSubjects;
        this.designationDetails = this.acadetails.designationDetails;
        if (this.acadetails.feedBackList.length > 0) {

          let reassignDate = this.acadetails.feedBackList[0]?.counselDate;
          this.startDate = new Date(moment(reassignDate).format());

          let reassigntarget = this.acadetails.feedBackList[0]?.targetActionPlan;
          this.tagetPlan = reassigntarget;

          let reassignadmNo = this.acadetails.feedBackList[0]?.admNo;
          this.academicTerm = reassignadmNo;

          if (this.acadetails?.feedBackList[0]?.counselStatus == 'Submitted') {
            this.isSubmittedForm = true;
          } else {
            this.isSubmittedForm = false;
          }

          let subjectWise = this.acadetails.feedBackList[0].feedbackDetails?.find((item: any) => item.counselTypeId == 1);
          if (subjectWise && subjectWise.typeWiseDetails.length > 0) {
            this.subjectWise = [];
            subjectWise.typeWiseDetails.map((item: any, index: any) => {
              item.isFromServer = true;
              this.subjectWise.push(item);
              this.facultydata(item.subjectId, index)
            })
          }

          let subjectdifficulties = this.acadetails.feedBackList[0].feedbackDetails?.find((item: any) => item.counselTypeId == 2);
          if (subjectdifficulties && subjectdifficulties.typeWiseDetails.length > 0) {
            this.subjectdifficulties = [];
            subjectdifficulties.typeWiseDetails.map((item: any, index: any) => {
              item.isFromServer = true;
              this.subjectdifficulties.push(item);
              this.facultydataDifficulty(item.subjectId, index);
            })
          }
    
          let subjectwisereason = this.acadetails.feedBackList[0].feedbackDetails?.find((item: any) => item.counselTypeId == 3);
          if (subjectwisereason && subjectwisereason.typeWiseDetails.length > 0) {
            this.subjectwisereason = [];
            subjectwisereason.typeWiseDetails.map((item: any, index: any) => {
              item.isFromServer = true;
              this.subjectwisereason.push(item);
              this.facultydatareasons(item.subjectId, index)

            })
          }
        
          let observationswise = this.acadetails.feedBackList[0].feedbackDetails?.find((item: any) => item.counselTypeId == 4);
          if (observationswise && observationswise.typeWiseDetails.length > 0) {
            this.observationswise = [];
            observationswise.typeWiseDetails.map((item: any, index: any) => {
              item.isFromServer = true;
              this.observationswise.push(item);
              this.facultydataobservation(item.designationId, index);

            })
          }

          let suggestionswise = this.acadetails.feedBackList[0].feedbackDetails?.find((item: any) => item.counselTypeId == 5);
          if (suggestionswise && suggestionswise.typeWiseDetails.length > 0) {
            this.suggestionswise = [];
            suggestionswise.typeWiseDetails.map((item: any, index: any) => {
              item.isFromServer = true;
              this.suggestionswise.push(item);
              this.facultydatasuggestion(item.designationId, index)
            })
          }

          let supportwise = this.acadetails.feedBackList[0].feedbackDetails?.find((item: any) => item.counselTypeId == 6);
          if (supportwise && supportwise.typeWiseDetails.length > 0) {
            this.supportwise = [];
            supportwise.typeWiseDetails.map((item: any, index: any) => {
              item.isFromServer = true;
              this.supportwise.push(item);
              this.facultydatasupport(item.designationId, index)
            })
          }
        } else {
          this.tagetPlan = '';

          this.subjectWise = [
            {
              subjectId: '',
              facultyId: '',
              feedback: '',
              feedbackStatus: 'Enabled'
            },
          ];
          // subjectdifficulties TO STORE THE DATA//
          this.subjectdifficulties = [
            {
              subjectId: '',
              facultyId: '',
              feedback: '',
              feedbackStatus: "Enabled"
            },
          ];
          //  REASONS FOR LOW PERFORMANCE   //
          this.subjectwisereason = [
            {
              subjectId: '',
              facultyId: '',
              feedback: '',
              feedbackStatus: "Enabled"
            }
          ];
          //  OBSERVATION BY   //
          this.observationswise = [
            {
              designationId: '',
              facultyId: '',
              feedback: '',
              feedbackStatus: "Enabled"
            }
          ];
          // SUGGESTION BY  //
          this.suggestionswise = [
            {
              designationId: '',
              facultyId: '',
              feedback: '',
              feedbackStatus: "Enabled"
            }
          ];
          // support required by  //
          this.supportwise = [
            {
              designationId: '',
              facultyId: '',
              feedback: '',
              feedbackStatus: "Enabled"
            }
          ];
          if (this.acadetails?.feedBackList[0]?.counselStatus == 'Submitted') {
            this.isSubmittedForm = true;
          } else {
            this.isSubmittedForm = false;
          }
        }
      }
    });
  }

  onSubjectSelect(event: any, index: any) {
    const selectedSubject = event.target.value;
    this.subjectWise[index].subjectId = parseInt(selectedSubject);
    this.facultydata(selectedSubject, index);
    this.isSubjectDisabled(this.subjectWise[index].subjectId);
  }

  facultydata(subjectId: any, index: any) {
    this.spinner.show();
    this.dataService.Academicsubjectselected(subjectId, this.admNo).subscribe((response) => {
      this.subjectWise[index].facultydetails = response;
      this.spinner.hide();
      console.log('facultydetail', this.subjectWise[index].facultydetails);
      console.log('subjectwise-faculty', this.subjectWise)
    });
  }

  onFacultySelect(event: any, index: number) {
    const selectedFaculty = event.target.value;
    console.log(selectedFaculty);
    this.subjectWise[index].facultyId = parseInt(selectedFaculty);
  }

  isRowEmpty(index: number): boolean {
    const rows = this.subjectWise[index];
    if (rows.facultyId == '' || rows.feedback.length <= 0) {
      return true;
    } else {
      return false;
    }
  }

  isSubjectDisabled(subjectId: any): boolean {
    let sujectwiseDisabledata = (this.subjectWise.some((rows: any) => rows.subjectId === subjectId && rows.feedbackStatus != 'Disabled'))
    if (sujectwiseDisabledata) {
      return true;
    } else {
      return false;
    }
  }

  // SUBJECT WISE DIFFICULTIES  //

  addsubjectwisedifficulties() {
    let subjectDtails = this.subjectdifficulties.filter((item: any) => item.feedbackStatus == 'Enabled')
    if (subjectDtails.length < this.subjectDetails.length) {
      this.subjectdifficulties.push({
        subjectId: '',
        facultyId: '',
        feedback: '',
        feedbackStatus: "Enabled"
      });
    }
  }

  deletesubjectwisedifficulties(index: any) {
    console.log('value', this.subjectdifficulties[index]);
    if (this.subjectdifficulties[index].isFromServer) {
      this.subjectdifficulties[index].feedbackStatus = 'Disabled';
    } else {
      this.subjectdifficulties[index].feedbackStatus = 'Disabled';
      this.subjectdifficulties.splice(index, 1);
    }

  }

  onSubjectSelectdifficulties(event: any, index: any) {
    const selectedSubjectdiffi = event.target.value;
    this.subjectdifficulties[index].subjectId = parseInt(selectedSubjectdiffi);
    this.facultydataDifficulty(selectedSubjectdiffi, index);
    this.issubjectDisabledDiff(this.subjectdifficulties[index].subjectId);
  }

  facultydataDifficulty(subjectId: any, index: any) {
    this.spinner.show();
    this.dataService.Academicsubjectselected(subjectId, this.difficultyadmNo).subscribe((res) => {
      this.subjectdifficulties[index].difficultyfacultydetails = res;
      console.log('difficulty', this.subjectdifficulties[index].difficultyfacultydetails);
      this.spinner.hide();
    });
  }

  onFacultySelectdiff(event: any, index: number) {
    const DiffiSelectedFaculty = event.target.value;
    console.log(DiffiSelectedFaculty);
    this.subjectdifficulties[index].facultyId = parseInt(DiffiSelectedFaculty);
  }

  isDiffRowEmpty(index: number): boolean {
    const row = this.subjectdifficulties[index];
    if (row.facultyId == '' || row.feedback.length <= 0) {
      return true;
    } else {
      return false;
    }
  }

  issubjectDisabledDiff(subjectId: any): boolean {
    let sujectDisabledata = (this.subjectdifficulties.some((row: any) => row.subjectId === subjectId && row.feedbackStatus != 'Disabled'));
    if (sujectDisabledata) {
      return true;
    } else {
      return false;
    }
  }

  //  REASONS FOR LOW PERFORMANCE   //

  addsubjectwisereasons() {
    let issubjectreasonDetails: any = [];
    this.subjectwisereason.map((item: any) => {
      console.log(item.feedbackStatus);
      if (item.feedbackStatus != 'Disabled') {
        issubjectreasonDetails.push(item)
      }
    })
    if (issubjectreasonDetails.length < this.subjectDetails.length) {
      this.subjectwisereason.push({
        subjectId: '',
        facultyId: '',
        feedback: '',
        feedbackStatus: "Enabled"
      });
    }
  }

  deletesubjectwisereasons(index: any) {
    if (this.subjectwisereason[index].isFromServer) {
      this.subjectwisereason[index].feedbackStatus = 'Disabled';
    } else {
      this.subjectwisereason[index].feedbackStatus = 'Disabled';
      this.subjectwisereason.splice(index, 1);
    }
  }

  onSubjectSelectreasons(event: any, index: any) {
    const selectedsubjectreasons = event.target.value;
    this.subjectwisereason[index].subjectId = parseInt(selectedsubjectreasons);
    this.facultydatareasons(selectedsubjectreasons, index);
    this.isreasonRowEmpty(index);
    this.issubjectDisabledreasons(this.subjectwisereason[index].subjectId)
  }

  facultydatareasons(subjectId: any, index: any) {
    this.spinner.show();
    this.dataService.Academicsubjectselected(subjectId, this.reasonsadmNo).subscribe((res) => {
      this.subjectwisereason[index].reasonfacultydetails = res;
      this.spinner.hide();
    });
    this.isreasonRowEmpty(index);
  }

  onFacultySelectreasons(event: any, index: any) {
    const reasonsSelectedFaculty = event.target.value;
    this.subjectwisereason[index].facultyId = parseInt(reasonsSelectedFaculty);
    this.isreasonRowEmpty(index);
  }

  isreasonRowEmpty(index: number): boolean {
    const row = this.subjectwisereason[index];
    if (row.facultyId == '' || row.feedback.length <= 0) {
      return true;
    } else {
      return false;
    }
  }

  issubjectDisabledreasons(subjectId: any): boolean {
    if (this.subjectwisereason.some((row: any) => row.subjectId === subjectId && row.feedbackStatus != 'Disabled')) {
      return true;
    } else {
      return false;
    }
  }

  // OBSERVATIONS BY //

  addobservation() {
    let isObservationDetails = this.observationswise.filter((item: any) => { item.feedbackStatus == 'Enabled' })
    if (isObservationDetails.length < this.designationDetails.length) {
      this.observationswise.push({
        designationId: '',
        facultyId: '',
        feedback: '',
        feedbackStatus: "Enabled"
      });
    }
  }

  deleteobservation(index: any) {
    if (this.observationswise[index].isFromServer) {
      this.observationswise[index].feedbackStatus = 'Disabled';
    } else {
      this.observationswise.splice(index, 1);
      this.observationswise[index].feedbackStatus = 'Disabled';
    }
  }

  onSubjectSelectobservation(event: any, index: any) {
    const selecteddesignation = event.target.value;
    this.observationswise[index].designationId = parseInt(selecteddesignation);
    this.facultydataobservation(selecteddesignation, index);
    this.isobservationRowEmpty(index);
  }

  facultydataobservation(designationId: any, index: any) {
    this.spinner.show();
    this.dataService.Academicdesignationselected(designationId, this.observationadmNo).subscribe((res) => {
      this.observationswise[index].observationfacultydetails = res;
      this.issubjectDisabledobservation(this.observationswise[index].facultyId);
      this.spinner.hide();
    });
    this.isobservationRowEmpty(index);
  }

  onFacultySelectobservation(event: any, index: any) {
    const observationSelectedFaculty = event.target.value;
    this.observationswise[index].facultyId = parseInt(observationSelectedFaculty);
    this.isobservationRowEmpty(index);
  }

  isobservationRowEmpty(index: number): boolean {
    const row = this.observationswise[index];
    if (row.facultyId == '' || row.feedback.length <= 0) {
      return true;
    } else {
      return false;
    }
  }

  issubjectDisabledobservation(facultyId: any): boolean {
    let data = this.observationswise.some((row: any) => row.facultyId === facultyId && row.feedbackStatus != 'Disabled');
    if (data) {
      return true;
    } else {
      return false;
    }
  }

  // SUGGESTION BY  //

  addsuggestions() {
    let isSuggestionDetails = this.suggestionswise.filter((item: any) => { item.feedbackStatus == 'Enabled' })
    if (isSuggestionDetails.length < this.designationDetails.length) {
      this.suggestionswise.push({
        designationId: '',
        facultyId: '',
        feedback: '',
        feedbackStatus: "Enabled"
      });
    }
  }

  deletesuggestions(index: any) {
    if (this.suggestionswise[index].isFromServer) {
      this.suggestionswise[index].feedbackStatus = 'Disabled';
    } else {
      this.suggestionswise[index].feedbackStatus = 'Disabled';
      this.suggestionswise.splice(index, 1);

    }
  }

  onSubjectSelectsuggestion(event: any, index: any) {
    const selecteddesignationsug = event.target.value;
    this.suggestionswise[index].designationId = parseInt(selecteddesignationsug);
    this.facultydatasuggestion(selecteddesignationsug, index);
    this.issuggestionRowEmpty(index);
  }

  facultydatasuggestion(designationId: any, index: any) {
    this.spinner.show();
    this.dataService.Academicdesignationselected(designationId, this.suggestionadmNo).subscribe((res) => {
      this.suggestionswise[index].suggestionfacultydetails = res;
      this.spinner.hide();
    });
    this.issuggestionRowEmpty(index);
  }

  onFacultySelectsuggestion(event: any, index: any) {
    const suggestionSelectedFaculty = event.target.value;
    this.suggestionswise[index].facultyId = parseInt(suggestionSelectedFaculty);
    this.issuggestionRowEmpty(index);
  }

  issuggestionRowEmpty(index: number): boolean {
    const row = this.suggestionswise[index];
    if (row.facultyId == '' || row.feedback.length <= 0) {
      return true;
    } else {
      return false;
    }
  }

  issubjectDisabledsuggestion(facultyId: any): boolean {
    let data = this.suggestionswise.find((row: any) => row.facultyId === facultyId && row.feedbackStatus != 'Disabled');
    if (data) {
      return true;
    } else {
      return false;
    }
  }

  // support required by 

  addsupport() {
    let isSupportDetails = this.supportwise.filter((item: any) => { item.feedbackStatus == 'Enabled' })
    if (isSupportDetails.length < this.designationDetails.length) {
      this.supportwise.push({
        designationId: '',
        facultyId: '',
        feedback: '',
        feedbackStatus: "Enabled"
      });
    }
  }

  deletesupport(index: any) {
    if (this.supportwise[index].isFromServer) {
      this.supportwise[index].feedbackStatus = 'Disabled';
    } else {
      this.supportwise[index].feedbackStatus = 'Disabled';
      this.supportwise.splice(index, 1);

    }
  }

  onSubjectSelectsupport(event: any, index: any) {
    const selecteddesignationsup = event.target.value;
    this.supportwise[index].designationId = parseInt(selecteddesignationsup);
    this.facultydatasupport(selecteddesignationsup, index);
    this.issupportRowEmpty(index);
  }

  facultydatasupport(designationId: any, index: any) {
    this.spinner.show();
    this.dataService.Academicdesignationselected(designationId, this.supportadmNo).subscribe((res) => {
      this.supportwise[index].supportfacultydetails = res;
      this.spinner.hide();
    });

    this.issupportRowEmpty(index);
  }
  onFacultySelectsupport(event: any, index: any) {
    const supportSelectedFaculty = event.target.value;
    this.supportwise[index].facultyId = parseInt(supportSelectedFaculty);
    this.issupportRowEmpty(index);
  }

  issupportRowEmpty(index: number): boolean {
    const row = this.supportwise[index];
    if (row.facultyId == '' || row.feedback.length <= 0) {
      return true;
    } else {
      return false;
    }
  }

  issubjectDisabledsupport(facultyId: any): boolean {
    let data = this.supportwise.find((row: any) => row.facultyId === facultyId && row.feedbackStatus != 'Disabled');
    if (data) {
      return true;
    } else {
      return false;
    }
  }

  // ALERT MEASSAGES  //

  isSUbjetWiseValid() {
    let isValid = false
    this.subjectWise.map((item: any) => {
      if (!(item.facultyId == '' || item.feedback == '' || item.subjectId == '')) {
        isValid = true;
      }
    });
    return isValid;
  }

  isSujectDiffValid() {
    let isValid = false;
    this.subjectdifficulties.map((item: any) => {
      if (!(item.subjectId == '' || item.facultyId == '' || item.feedback == '')) {
        isValid = true;
      }
    });
    return isValid;
  }

  isSujectreaValid() {
    let isValid = false;
    this.subjectwisereason.map((item: any) => {
      if (!(item.subjectId == '' || item.facultyId == '' || item.feedback == '')) {
        isValid = true;
      }
    });
    return isValid;
  }

  isSujectobsValid() {
    let isValid = false;
    this.observationswise.map((item: any) => {
      if (!(item.designationId == '' || item.facultyId == '' || item.feedback == '')) {
        isValid = true;
      }
    });
    return isValid;
  }

  isSujectsugValid() {
    let isValid = false;
    this.suggestionswise.map((item: any) => {
      if (!(item.designationId == '' || item.facultyId == '' || item.feedback == '')) {
        isValid = true;
      }
    });
    return isValid;
  }

  isSujectsupValid() {
    let isValid = false;
    this.supportwise.map((item: any) => {
      if (!(item.designationId == '' || item.facultyId == '' || item.feedback == '')) {
        isValid = true;
      }
    });
    return isValid;
  }


  save() {
    let isSubwiseValis = this.isSUbjetWiseValid()
    if (!isSubwiseValis) {
    }

    let isSubDiffValis = this.isSujectDiffValid()
    if (!isSubDiffValis) {
    }

    let isSubreaValis = this.isSujectreaValid()
    if (!isSubreaValis) {
      // alert('subRea falid');
    }

    let isSubobsValis = this.isSujectobsValid()
    if (!isSubobsValis) {
    }

    let isSubsugValis = this.isSujectsugValid()
    if (!isSubsugValis) {
    }

    let isSubsupValis = this.isSujectsupValid()
    if (!isSubsupValis) {
    }
    if (isSubsupValis || isSubsugValis || isSubobsValis || isSubreaValis || isSubDiffValis || isSubwiseValis) {
      const duplicateData = !isSubwiseValis ? [] : this.subjectWise.map((item: { [x: string]: any; facultydetails: any; }) => {
        const { facultydetails, ...newItem } = item;
        return newItem;
      });

      const duplicate_difficulty = !isSubDiffValis ? [] : this.subjectdifficulties.map((item: { [x: string]: any; difficultyfacultydetails: any; }) => {
        const { difficultyfacultydetails, ...newItem } = item;
        return newItem;
      });

      const duplicate_reasons = !isSubreaValis ? [] : this.subjectwisereason.map((item: { [x: string]: any; reasonfacultydetails: any; }) => {
        const { reasonfacultydetails, ...newItem } = item;
        return newItem;
      });
    
      const duplicate_observations = !isSubobsValis ? [] : this.observationswise.map((item: { [x: string]: any; observationfacultydetails: any; }) => {
        const { observationfacultydetails, ...newItem } = item;
        return newItem;
      });
  
      const duplicate_suggestions = !isSubsugValis ? [] : this.suggestionswise.map((item: { [x: string]: any; suggestionfacultydetails: any; }) => {
        const { suggestionfacultydetails, ...newItem } = item;
        return newItem;
      });
    
      const duplicate_support = !isSubsupValis ? [] : this.supportwise.map((item: { [x: string]: any; supportfacultydetails: any; }) => {
        const { supportfacultydetails, ...newItem } = item;
        return newItem;
      });

      const filterData = [
        {
          "counselTypeId": duplicateData.length == 0 ? null : 1,
          "typeWiseDetails": duplicateData
        },
        {
          "counselTypeId": duplicate_difficulty.length == 0 ? null : 2,
          "typeWiseDetails": duplicate_difficulty
        },
        {
          "counselTypeId": duplicate_reasons.length == 0 ? null : 3,
          "typeWiseDetails": duplicate_reasons
        },
        {
          "counselTypeId": duplicate_observations.length == 0 ? null : 4,
          "typeWiseDetails": duplicate_observations
        },
        {
          "counselTypeId": duplicate_suggestions.length == 0 ? null : 5,
          "typeWiseDetails": duplicate_suggestions
        },
        {
          "counselTypeId": duplicate_support.length == 0 ? null : 6,
          "typeWiseDetails": duplicate_support
        }
      ].filter((el: any) => el.counselTypeId !== null)
      var payload = {
        "admNo": this.admNo,
        "counselDate": moment(this.startDate).format("DD-MMM-YYYY"),
        "targetActionPlan": this.tagetPlan ? this.tagetPlan : '',
        "counselStatus": "PENDING",
        "feedbackDetails": filterData

      }
      this.spinner.show();
      this.dataService.academicsave(payload).subscribe((res: any) => {
        this.show = true;
        this.spinner.hide();
      });
    } else {
      alert('Please fill atleast one')
    }
  }

  onacademicShow(event: { emitValue: boolean, studentData: any }) {
    this.show = event.emitValue;
    this.receivedStudentData = event.studentData.admNo;
    this.academicsearch(event.studentData.admNo);
    // Now you can use both values as needed
  }

  // FINE SUBMIT ACADEMIC DETAILS //

  submit() {
    if (this.myform.invalid) {
      alert('Please Enter Target Action Plan Week')
    } else {
      let isSubwiseValis = this.isSUbjetWiseValid()
      if (!isSubwiseValis) {
        // alert('subwise falid');
      }

      let isSubDiffValis = this.isSujectDiffValid()
      if (!isSubDiffValis) {
      }

      let isSubreaValis = this.isSujectreaValid()
      if (!isSubreaValis) {
      }

      let isSubobsValis = this.isSujectobsValid()
      if (!isSubobsValis) {
      }

      let isSubsugValis = this.isSujectsugValid()
      if (!isSubsugValis) {
      }

      let isSubsupValis = this.isSujectsupValid()
      if (!isSubsupValis) {
      }

      if (isSubsupValis || isSubsugValis || isSubobsValis || isSubreaValis || isSubDiffValis || isSubwiseValis) {
        const duplicateData = !isSubwiseValis ? [] : this.subjectWise.map((item: { [x: string]: any; facultydetails: any; }) => {
          const { facultydetails, ...newItem } = item;
          return newItem;
        });

        const duplicate_difficulty = !isSubDiffValis ? [] : this.subjectdifficulties.map((item: { [x: string]: any; difficultyfacultydetails: any; }) => {
          const { difficultyfacultydetails, ...newItem } = item;
          return newItem;
        });
       
        const duplicate_reasons = !isSubreaValis ? [] : this.subjectwisereason.map((item: { [x: string]: any; reasonfacultydetails: any; }) => {
          const { reasonfacultydetails, ...newItem } = item;
          return newItem;
        });

        const duplicate_observations = !isSubobsValis ? [] : this.observationswise.map((item: { [x: string]: any; observationfacultydetails: any; }) => {
          const { observationfacultydetails, ...newItem } = item;
          return newItem;
        });
    
        const duplicate_suggestions = !isSubsugValis ? [] : this.suggestionswise.map((item: { [x: string]: any; suggestionfacultydetails: any; }) => {
          const { suggestionfacultydetails, ...newItem } = item;
          return newItem;
        });
   
        const duplicate_support = !isSubsupValis ? [] : this.supportwise.map((item: { [x: string]: any; supportfacultydetails: any; }) => {
          const { supportfacultydetails, ...newItem } = item;
          return newItem;
        });

        const filterData = [
          {
            "counselTypeId": duplicateData.length == 0 ? null : 1,
            "typeWiseDetails": duplicateData
          },
          {
            "counselTypeId": duplicate_difficulty.length == 0 ? null : 2,
            "typeWiseDetails": duplicate_difficulty
          },
          {
            "counselTypeId": duplicate_reasons.length == 0 ? null : 3,
            "typeWiseDetails": duplicate_reasons
          },
          {
            "counselTypeId": duplicate_observations.length == 0 ? null : 4,
            "typeWiseDetails": duplicate_observations
          },
          {
            "counselTypeId": duplicate_suggestions.length == 0 ? null : 5,
            "typeWiseDetails": duplicate_suggestions
          },
          {
            "counselTypeId": duplicate_support.length == 0 ? null : 6,
            "typeWiseDetails": duplicate_support
          }
        ].filter((el: any) => el.counselTypeId !== null)
        var payload = {
          "admNo": this.admNo,
          "counselDate": moment(this.startDate).format("DD-MMM-YYYY"),
          "targetActionPlan": this.tagetPlan ? this.tagetPlan : '',
          "counselStatus": "Submitted",
          "feedbackDetails": filterData
        }
        if (confirm('Do you want to save Academic Counselling Report Details')) {
          this.dataService.academicsave(payload).subscribe((res: any) => {
            this.show = true;
          });
          window.alert("Academic Counselling Report Details Saved Successfully");
        }
      } else {
        this.spinner.hide();
        alert('Please fill atleast one')
      }

    }
  }

  togglechildvisibility() {
    this.show = true;
  }

  onTableDataShow(e: any) {
    this.show = e;
  }

}











